import React from "react";

/**
 * Indicador de progresso do funil de agendamento.
 *
 * Trabalha com indices 1-based proprios (1, 2, 3...), independentes do valor
 * de step usado pela pagina — cabe a quem renderiza fazer o mapeamento.
 *
 * Permite voltar para etapas ja concluidas e nunca avancar, para que o usuario
 * nao pule uma escolha obrigatoria.
 *
 * @param {{label: string}[]} steps  etapas, na ordem
 * @param {number} currentStep       etapa atual (1-based)
 * @param {(step: number) => void} onStepClick  chamado ao voltar para uma etapa
 */
export default function Stepper({ steps, currentStep, onStepClick }) {
  function goToStep(step) {
    // so permite voltar para etapas ja concluidas, nunca pular pra frente
    if (step >= currentStep) return;
    onStepClick(step);
  }

  return (
    <div
      className="app-stepper"
      role="group"
      aria-label="Progresso do agendamento"
    >
      {steps.map(({ label }, index) => {
        const step = index + 1;
        const isActive = step === currentStep;
        const isDone = step < currentStep;
        const isClickable = isDone;

        return (
          <React.Fragment key={label}>
            {index > 0 && (
              <div
                className={
                  "app-stepper-line" +
                  (step <= currentStep ? " app-stepper-line-filled" : "")
                }
              />
            )}
            <div
              className={
                "app-stepper-item" +
                (isActive ? " app-stepper-item-active" : "") +
                (isClickable ? " app-stepper-item-clickable" : "")
              }
              onClick={() => goToStep(step)}
              onKeyDown={(e) => {
                if (isClickable && (e.key === "Enter" || e.key === " ")) {
                  e.preventDefault();
                  goToStep(step);
                }
              }}
              role={isClickable ? "button" : undefined}
              tabIndex={isClickable ? 0 : undefined}
              aria-current={isActive ? "step" : undefined}
              aria-label={`Etapa ${step} de ${steps.length}: ${label}${
                isDone ? " (concluída)" : isActive ? " (atual)" : ""
              }`}
            >
              <span
                className={
                  "app-stepper-circle" +
                  (isDone ? " app-stepper-circle-done" : "")
                }
              >
                {isDone ? (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M2 6L5 9L10 3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  step
                )}
              </span>
              <span className="app-stepper-label">{label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
